import { Controller } from "@hotwired/stimulus"

// Dismiss a banner and remember it in localStorage so it stays gone.
// Usage: data-controller="dismissible" data-dismissible-key-value="connect-stripe"
//        + a close button with data-action="dismissible#dismiss"
export default class extends Controller {
  static values = { key: String }

  connect() {
    if (this.#dismissed) this.element.remove()
  }

  dismiss() {
    if (this.hasKeyValue) localStorage.setItem(this.#storageKey, "1")
    this.element.remove()
  }

  get #dismissed() {
    return this.hasKeyValue && localStorage.getItem(this.#storageKey) === "1"
  }

  get #storageKey() {
    return `banner-dismissed:${this.keyValue}`
  }
}
